import { getStates, getTodos, getParticipants, deleteTodo, getBoards } from '../api'
import axios from 'axios'
import { cloneDeep, orderBy } from 'lodash'

export default {
  namespaced: true,
  state: {
    activeParticipantsIds: [],
    states: null,
    todos: null,
    participants: null,
    boards: null
  },

  getters: {
    board(state) {
      if (!state.todos) return
      const copiedState = cloneDeep(state)
      const { participants, todos, states } = copiedState
      let calcStates = states.map(s => {
        s.tasks = todos.filter(t => t.state && t.state.id === s.id)
        s.tasks = s.tasks.map(t => {
          t.kanban_position = Number(t.kanban_position)
          return t
        })
        if (s.tasks.length) s.tasks = orderBy(s.tasks, 'kanban_position')
        s.kanban_position = Number(s.kanban_position)
        return s
      })
      calcStates = orderBy(calcStates, 'kanban_position')

      return {
        id: 1,
        name: 'Roam Workflow',
        states: calcStates,
        participants
      }
    }
  },

  mutations: {
    setStates: (state, payload) => (state.states = payload),
    addState: (state, payload) => state.states.push(payload),
    deleteState(state, stateId) {
      const index = state.states.findIndex(s => s.id === stateId)
      if (~index) state.states.splice(index, 1)
    },

    updateState: (state, payload) => {
      const index = state.states.findIndex(s => s.id === payload.id)
      if (~index) state.states.splice(index, 1, payload)
    },

    setTodos: (state, payload) => (state.todos = payload),
    setParticipants: (state, payload) => (state.participants = payload),

    updateTask(state, task) {
      const index = state.todos.findIndex(t => t.id === task.id)
      if (~index) state.todos.splice(index, 1, task)
    },

    toggleParticipants(state, id) {
      if (state.activeParticipantsIds.includes(id)) {
        state.activeParticipantsIds = state.activeParticipantsIds.filter(p => p !== id)
      } else {
        state.activeParticipantsIds.push(id)
      }
    },

    addNewTodo: (state, todo) => state.todos.push(todo),
    deleteTodo(state, todoId) {
      const index = state.todos.findIndex(t => t.id === todoId)
      if (~index) state.todos.splice(index, 1)
    },
    incrementOrDecrementCheckListCount(state, { todoId, increment }) {
      // increment can be either 1 or -1
      const index = state.todos.findIndex(t => t.id === todoId)
      state.todos[index].checklist_items_count += increment
    },

    incrementOrDecrementFilesCount(state, { todoId, increment }) {
      // increment can be either 1 or -1
      const index = state.todos.findIndex(t => t.id === todoId)
      state.todos[index].media_count += increment
    },

    incrementOrDecrementCommentsCount(state, { todoId, increment }) {
      // increment can be either 1 or -1
      const index = state.todos.findIndex(t => t.id === todoId)
      state.todos[index].comments_count += increment
    },

    setBoards: (state, boards) => (state.boards = boards),

    resetState(state) {
      state.activeParticipantsIds = []
      state.states = null
      state.todos = null
      state.participants = null
      state.boards = null
    }
  },

  actions: {
    fetchBoard({ commit }, boardId) {
      commit('setTodos', null) // clear todos
      return axios.all([getStates(boardId), getTodos(boardId), getParticipants()]).then(
        axios.spread(({ data: statesApi }, { data: todosApi }, { data: participantsApi }) => {
          commit('setStates', statesApi.result)
          commit('setTodos', todosApi.result)
          commit('setParticipants', participantsApi.result)
        })
      )
    },

    deleteStateWithTodos({ commit, state }, stateId) {
      const unscheduledStateId = state.states.find(s => s.slug === 'unscheduled').id
      const todos = cloneDeep(state.todos)
      todos.forEach(todo => {
        if (todo.state && todo.state.id === stateId) todo.state.id = unscheduledStateId
      })
      commit('deleteState', stateId)
      commit('setTodos', todos)
    },

    async deleteTodo({ commit }, todoId) {
      await deleteTodo(todoId).then(() => commit('deleteTodo', todoId))
      getParticipants().then(({ data }) => commit('setParticipants', data.result))
    },

    todoCreated({ commit }, newTodo) {
      commit('addNewTodo', newTodo)
      getParticipants().then(({ data }) => commit('setParticipants', data.result))
    },

    todoUpdated({ commit }, todo) {
      commit('updateTask', todo)
      getParticipants().then(({ data }) => commit('setParticipants', data.result))
    },

    getAndSetBoards({ commit }) {
      return getBoards().then(({ data }) => commit('setBoards', data.result))
    }
  }
}
